import request from '@/utils/request'

// 查询采购客户列表分页
export function fetchList(query) {
    return request({
        url: '/taxation/user/tenant/page',
        method: 'get',
        params: query,
    })
}
// 查询采购客户详细
export function getObj(id) {
    return request({
        url: '/taxation/user/tenant/detail?id=' + id,
        method: 'get',
    })
}
//  审核
// 采购客户
export function addObj(data) {
    return request({
        url: '/taxation/user/tenant/examine',
        method: 'post',
        data: data,
    })
}
// 禁用启用 维修首页状态
export function statusObj(data) {
    return request({
        url: '/taxation/user/tenant/status',
        method: 'post',
        data: data,
    })
}
// 修改采购客户
export function putObj(data) {
    return request({
        url: '/taxation/user/tenant/edit',
        method: 'post',
        data: data,
    })
}
// 删除采购客户
export function delObj(data) {
    return request({
        url: '/upkeep/script/delete',
        method: 'post',
        data: data,
    })
}

export function fetchEnterpriseList(query) {
    return request({
      url: '/system/tenant/page',
        method: 'get',
        params: query,
    })
}

export function fetchAgentList(query) {
    return request({
        url: '/system/tenant/page',
        method: 'get',
        params: query,
    })
}
